import BaseDataObject from './BaseDataObject';

export default class BetConfig extends BaseDataObject {
  /*
    public String name;
    public int nrOfSystems; // 1, 2, 5, 10, 20, 50, 100
    public int guaranteePercent; // 0 - 100
    public int numberOfErrorsGuarantee; // 4, 5, 6, 7, 8
    public int nrOfFaultingReductionsToTolerate; // 0 - 7
    public SpareType typeOfSpare; // "NONE", "DECIDED", "BEST_RANKED", "NEXT_RANKED", "NEXT_LETTER"
    public boolean v6;
    public int raceNumber;
    public int stake; // 5, 10, 20, 30, 40, 50, 100, 200
    */

  getName = () => this.getString('name');
  setName = v => this.setString('name', v);

  getNumberOfSystems = () => this.getInteger('nrOfSystems');
  setNumberOfSystems = v => this.setInteger('nrOfSystems', v);

  getGuaranteePercent = () => this.getInteger('guaranteePercent');
  setGuaranteePercent = v => this.setInteger('guaranteePercent', v);

  getNumberOfFaultingReductionsToTolerate = () =>
    this.getInteger('nrOfFaultingReductionsToTolerate');
  setNumberOfFaultingReductionsToTolerate = v =>
    this.setInteger('nrOfFaultingReductionsToTolerate', v);

  getSpareType = () => this.getString('typeOfSpare');
  setSpareType = v => this.setString('typeOfSpare', v);

  getV6 = () => this.getBoolean('v6');
  setV6 = v => this.setBoolean('v6', v);
  hasV6 = () => this.has('v6');

  getV7 = () => this.getBoolean('v7');
  setV7 = v => this.setBoolean('v7', v);
  hasV7 = () => this.has('v7');

  getRaceNumber = () => this.getInteger('raceNumber');
  setRaceNumber = v => this.setInteger('raceNumber', v);

  getStake = () => this.getInteger('stake');
  setStake = v => this.setInteger('stake', v);

  getShowResultRows = () => this.getIntegerArray('showResultRows');
  setShowResultRows = rows => this.setIntegerArray('showResultRows', rows);

  getShowResultRow = rowIndex => this.getShowResultRows().includes(rowIndex);
  setShowResultRow(rowIndex, show) {
    const rows = this.getShowResultRows();
    const i = rows.indexOf(rowIndex);

    if (show) {
      if (i === -1) {
        rows.push(rowIndex);
      }
    } else {
      if (i !== -1) {
        rows.splice(i, 1);
      }
    }
    this.setShowResultRows(rows);
  }

  isPublished = () => this.getBoolean('isPublished');
  setPublished = value => this.setBoolean('isPublished', value);

  setPublishDate = value => this.setDate('publishDate', value);
  getPublishDate = () => this.getDate('publishDate');

  setNumberOfErrorsGuarantee = v =>
    this.setInteger('numberOfErrorsGuarantee', v);
  getNumberOfErrorsGuarantee = () =>
    this.getInteger('numberOfErrorsGuarantee', 0);

  isFromJokerWiz = () => this.getBoolean('fromJokerWiz');

  isShared = () => this.getBoolean('isShared');
  isLocked = () => this.getBoolean('isLocked');

  setLocked = locked => this.setBoolean('isLocked', locked);

  setLockTime = value => this.setInteger('lockTime', value);
  getLockTime = () => this.getInteger('lockTime');

  setTemplate = v => this.setInteger('templateId', v);

  getTrendFormattedTimestamp = () =>
    this.getString('trendFormattedTimestamp', null);

  setTrendFormattedTimestamp = value =>
    this.setString('trendFormattedTimestamp', value);
}
